import React from "react";
import { Column, useTable } from "react-table";
import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
} from "@mui/material";

interface ITableProps<T extends {}> {
  columns: Column<T>[];
  data: T[];
  stickyHeader?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const Datatable = <T extends {}>({
  columns,
  data,
  ...tableProps
}: ITableProps<T>) => {
  const { getTableProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  });
  const { key: tableKey, ...tableRestProps } = getTableProps() as any;
  return (
    <Table key={tableKey} {...tableProps} {...tableRestProps}>
      <TableHead className="bg-gray-100">
        {headerGroups.map((headerGroup) => {
          const { key, ...rest } = headerGroup.getHeaderGroupProps() as any;
          return (
            <TableRow key={key} {...rest}>
              {headerGroup.headers.map((column) => {
                const { key, ...rest } = column.getHeaderProps();
                return (
                  <TableCell key={key} {...rest}>
                    <div className="text-xs font-bold">
                      {column.render("Header")}
                    </div>
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </TableHead>
      <TableBody>
        {rows.map((row) => {
          prepareRow(row);
          const { key, ...rest } = row.getRowProps();
          return (
            <TableRow key={key} {...rest}>
              {row.cells.map((cell) => {
                const { key, ...rest } = cell.getCellProps();
                return (
                  <TableCell key={key} {...rest}>
                    <div className="text-xs">{cell.render("Cell")}</div>
                  </TableCell>
                );
              })}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
export default Datatable;
